import type { ReactNode } from 'react';

import { TagDangerRounded } from '@components/core-ui/Tag/variations/TagDangerRounded';
import { TagInfoRounded } from '@components/core-ui/Tag/variations/TagInfoRounded';
import { TagMutedRounded } from '@components/core-ui/Tag/variations/TagMutedRounded';
import { TagSuccessRounded } from '@components/core-ui/Tag/variations/TagSuccessRounded';
import type { TTagProps } from '@components/core-ui/Tag/types/TProps';

const isSuccessfulStatus = (status?: string | null) => {
  if (!status) {
    return false;
  }
  const normalized = status.toLowerCase();
  return normalized.includes('success') || normalized.includes('complete');
};

export function statusBadgeKind(status?: string | null): 'muted' | 'danger' | 'success' | 'info' {
  if (!status) {
    return 'muted';
  }
  const normalized = status.toLowerCase();
  if (normalized.includes('fail') || normalized.includes('error')) {
    return 'danger';
  }
  if (isSuccessfulStatus(status)) {
    return 'success';
  }
  if (normalized.includes('start') || normalized.includes('progress') || normalized.includes('running')) {
    return 'info';
  }
  return 'muted';
}

type TProps = Omit<TTagProps, 'children'> & {
  status: string | null | undefined;
  children: ReactNode;
};

export function PipelineStatusTag({ status, className, style, children }: TProps) {
  const k = statusBadgeKind(status);
  const shared = { className, style, children };
  if (k === 'danger') {
    return <TagDangerRounded {...shared} />;
  }
  if (k === 'success') {
    return <TagSuccessRounded {...shared} />;
  }
  if (k === 'info') {
    return <TagInfoRounded {...shared} />;
  }
  return <TagMutedRounded {...shared} />;
}
